import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { clearLocalStorage, getUserStorageData, recordUserData } from '../../helpers/storage';
import { AuthResponse, SignInResponse, addUserRequest, signInRequest } from '../../types';
import { AuthAction, RegistrationActionTypes, SignInActionTypes } from '../type';
import { addUser, getUser, signIn } from '../../api/signIn';

export const register = (data: addUserRequest) => {
  return async (dispatch: Dispatch<AuthAction>) => {
    try {
      dispatch({
        type: RegistrationActionTypes.REGISTRATION,
        payload: data.email,
      });
      addUser(data.name, data.email, data.password)
        .then((data) => {
          dispatch({ type: RegistrationActionTypes.SUCCESS, payload: data as AuthResponse });
        })
        .catch((data) => {
          const message = data.response.data;
          toast.error(message);
          dispatch({
            type: SignInActionTypes.ERROR,
            payload: message,
          });
        });
    } catch (error) {}
  };
};

export const login = (data: signInRequest) => {
  return async (dispatch: Dispatch<AuthAction>) => {
    try {
      dispatch({
        type: SignInActionTypes.SIGNIN,
      });
      signIn(data.email, data.password)
        .then((data) => {
          dispatch({ type: SignInActionTypes.SUCCESS, payload: data as SignInResponse });
          recordUserData(data);
        })
        .catch((data) => {
          const message = data.response.data;
          toast.error(message);
          dispatch({
            type: SignInActionTypes.ERROR,
            payload: message,
          });
        });
    } catch (error) {}
  };
};

export const logout = () => {
  return async (dispatch: Dispatch<AuthAction>) => {
    dispatch({ type: SignInActionTypes.SIGN_OUT });
    clearLocalStorage();
  };
};
export const TryAuthAction = () => async (dispatch: Dispatch<AuthAction>) => {
  const prevAuth = await window.localStorage.getItem('LS_AUTH_KEY');

  if (prevAuth) {
    const prevAuthObject = JSON.parse(prevAuth);
    getUser(prevAuthObject.userId)
      .then((data) => {
        dispatch({
          type: SignInActionTypes.REFRESH_AUTH,
          payload: { token: prevAuthObject, user: data },
        });
        dispatch({ type: SignInActionTypes.SUCCESS, payload: prevAuthObject });
      })
      .catch(() => {
        dispatch({ type: SignInActionTypes.SIGN_OUT });
        window.localStorage.removeItem('LS_AUTH_KEY');
      });
  }
};

export const fetchGetUser =
  (userId: string | null, token: string | null) => async (dispatch: Dispatch<AuthAction>) => {
    if (!userId || !token) return;

    getUser(userId)
      .then((data) => {
        dispatch({
          type: SignInActionTypes.REFRESH_AUTH,
          payload: { token: token, user: data },
        });
        const userData = getUserStorageData();
        dispatch({ type: SignInActionTypes.SUCCESS, payload: userData as SignInResponse });
      })
      .catch(() => {
        dispatch({ type: SignInActionTypes.SIGN_OUT });
        window.localStorage.removeItem('LS_AUTH_KEY');
      });
  };
